(() => {
  const selector = '.tx-bedding-swatch[data-swatch-item]';

  function sync(group) {
    group.querySelectorAll(selector).forEach((item) => {
      item.setAttribute('aria-pressed', item.classList.contains('is--selected') ? 'true' : 'false');
    });
  }

  function init(root = document) {
    root.querySelectorAll('.t4s-swatch__option.is-t4s-style__color').forEach(sync);
  }

  document.addEventListener('keydown', (event) => {
    const item = event.target.closest(selector);
    if (!item || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    item.click();
  });

  document.addEventListener('click', (event) => {
    const item = event.target.closest(selector);
    if (!item) return;
    window.setTimeout(() => sync(item.closest('.t4s-swatch__option')), 0);
  });

  document.addEventListener('change', (event) => {
    const form = event.target.closest('.t4s-form__product');
    if (!form) return;
    window.setTimeout(() => init(form), 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
})();